/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_content_delivery_bucket": "react-r-tools-hostingbucket-prod",
    "aws_content_delivery_bucket_region": "us-west-2",
    "aws_content_delivery_url": "http://react-r-tools-hostingbucket-prod.s3-website-us-west-2.amazonaws.com",
    "aws_cognito_identity_pool_id": "us-west-2:12ff9cd7-6902-4cb6-8704-96be5de918f8",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_sQcxVMZv9",
    "aws_user_pools_web_client_id": "5kq9t59l5uddcdsrg1910fninm",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://osd2oe6forbezj776zlnyhuxxi.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_user_files_s3_bucket": "react-r-toolstools-prod",
    "aws_user_files_s3_bucket_region": "us-west-2"
};


export default awsmobile;
